export default __webpack_public_path__ + "static/media/loading1.5f4ce6b3.png";